export default "__VITE_ASSET__4d44b092__"